import {
  CharacterRef,
  Position,
  TextRef,
  RiggedCharacterRef,
} from '../../../types/typing';
import { Graphics, Application } from 'pixi.js';
import React from 'react';

function isCharacterRef(obj: any): obj is CharacterRef {
  // CharacterRef has sprite but not container (RiggedCharacterRef has both)
  return (
    (obj as CharacterRef).sprite !== undefined &&
    (obj as RiggedCharacterRef).container === undefined
  );
}

function isRiggedCharacterRef(obj: any): obj is RiggedCharacterRef {
  return (
    (obj as RiggedCharacterRef).container !== undefined &&
    (obj as RiggedCharacterRef).rig !== undefined
  );
}

function isTextRef(obj: any): obj is TextRef {
  return (obj as TextRef).textContainer !== undefined;
}

// Store last capture timestamp globally
let lastCaptureTime = 0;

export const startRecording = (
  event: any,
  assetRef: React.MutableRefObject<Map<string, CharacterRef | TextRef>>,
  id: string,
  app: Application,
  dragOffset: any
) => {
  const points = event.data.global;
  const selectedCharacter = assetRef.current.get(id);

  // if (selectedCharacter) {
  //   selectedCharacter.pathPoints.push({x: points.x - dragOffset.x, y: points.y - dragOffset.y});
  // }

  if (selectedCharacter) {
    const currentTime = Date.now();
    if (currentTime - lastCaptureTime >= 10) {
      // Ensure 10ms gap
      selectedCharacter.pathPoints.push({
        x: points.x - dragOffset.x,
        y: points.y - dragOffset.y,
      });
      lastCaptureTime = currentTime; // Update last capture time
    }
  }

  // Draw visualization circle
  const path = new Graphics();
  path.interactive = false;
  path.beginFill(0xff0000);
  path.drawCircle(points.x, points.y, 2);
  path.endFill();

  if (selectedCharacter) {
    selectedCharacter.pathCircles.push(path);
    app.stage.addChild(path);
  }

  // Hide/show based on condition
  // const dotSpacing = 10; // Adjust the space between dots
  // let lastPoint: { x: number; y: number } | null = null;

  // // Function to draw a dot
  // const drawDot = (x: number, y: number) => {
  //   graphics.beginFill(0xff0000);
  //   graphics.drawCircle(x, y, 3); // Small dot
  //   graphics.endFill();
  // };

  // // Function to add points with spacing control
  //   if (!lastPoint || Math.hypot(x - lastPoint.x, y - lastPoint.y) >= dotSpacing) {
  //     drawDot(x, y);
  //     lastPoint = { x, y }; // Update last point
  //   }
};

export const updateCircleVisibility = (
  pathCircles: Graphics[] | null,
  selectedMenuRef: React.MutableRefObject<string | null | undefined>
) => {
  // Directly set visibility based on current menu selection
  if (pathCircles) {
    for (let i = pathCircles.length - 1; i >= 0; i--) {
      const currentCircle = pathCircles[i];
      if (currentCircle && currentCircle instanceof Graphics) {
        console.log(
          'Updating circle visibility to - ',
          selectedMenuRef?.current === 'animations'
        );
        currentCircle.visible = selectedMenuRef?.current === 'animations';
      }
    }
  }
};

export const stopRecording = (
  assetRef: React.MutableRefObject<Map<string, CharacterRef | TextRef>>,
  onUpdateCharacter: (
    id: string,
    properties: { position?: Position; scale?: number }
  ) => void
) => {
  const selectedAssetId = [...assetRef.current.entries()]
    // @ts-ignore
    .find(([id, char]) => char.isSelected)?.[0];

  if (selectedAssetId) {
    const selectedAsset = assetRef.current.get(selectedAssetId);

    if (
      selectedAsset &&
      selectedAsset.pathPoints &&
      selectedAsset.pathPoints.length > 0
    ) {
      const firstPoint = selectedAsset.pathPoints[0];
      const recordedPathPoints = [...selectedAsset.pathPoints]; // Store the path points before clearing

      // Set the character's position to the first point and reset alpha
      if (isCharacterRef(selectedAsset) && selectedAsset.sprite) {
        selectedAsset.sprite.alpha = 1; // Reset alpha first
        onUpdateCharacter(selectedAssetId, {
          position: {
            x: firstPoint.x,
            y: firstPoint.y,
          },
        });
        selectedAsset.sprite.x = firstPoint.x;
        selectedAsset.sprite.y = firstPoint.y;
      } else if (
        isRiggedCharacterRef(selectedAsset) &&
        selectedAsset.container
      ) {
        selectedAsset.container.alpha = 1; // Reset alpha first
        onUpdateCharacter(selectedAssetId, {
          position: {
            x: firstPoint.x,
            y: firstPoint.y,
          },
        });
        selectedAsset.container.x = firstPoint.x;
        selectedAsset.container.y = firstPoint.y;
      } else if (isTextRef(selectedAsset) && selectedAsset.textContainer) {
        selectedAsset.textContainer.alpha = 1; // Reset alpha first
        selectedAsset.textContainer.x = firstPoint.x;
        selectedAsset.textContainer.y = firstPoint.y;
      }

      // Only clear the recording state, but keep the selection, path points and circles
      selectedAsset.isRecording = false; // Reset the recording state

      // Return the recorded movements for any further processing
      return recordedPathPoints;
    }

    // If there's a selected asset but no path points, still reset its state
    if (selectedAsset) {
      if (isCharacterRef(selectedAsset) && selectedAsset.sprite) {
        selectedAsset.sprite.alpha = 1;
      } else if (
        isRiggedCharacterRef(selectedAsset) &&
        selectedAsset.container
      ) {
        selectedAsset.container.alpha = 1;
      } else if (isTextRef(selectedAsset) && selectedAsset.textContainer) {
        selectedAsset.textContainer.alpha = 1;
      }
      selectedAsset.isRecording = false;
    }
  }

  // Return empty array if no path points were recorded
  return [];
};
